import { gql } from '@apollo/client';

export type RatingAnswerCheck = {
  ratingAnswers: { documentId: string }[];
};

export const getRatesForUser = gql`
  query GetRatesForUser($email: String!, $ratingId: ID!) {
    ratingAnswers(
      filters: {
        user: { email: { eq: $email } }
        and: [{ rating: { documentId: { eq: $ratingId } } }]
      }
    ) {
      documentId
    }
  }
`;
